// src/pages/Panels/PanelViewModal.jsx
import {
    Badge,
    Button,
    HStack,
    ListItem,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    UnorderedList,
    VStack,
} from '@chakra-ui/react';

export default function PanelViewModal({ isOpen, onClose, panel }) {
    if (!panel) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Panel Details</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack align="start" spacing={3}>
                        <Text><b>Name:</b> {panel.name}</Text>
                        <Text><b>Description:</b> {panel.description || '-'}</Text>
                        <Text><b>Status:</b> {panel.deletedAt ? 'Deleted' : 'Active'}</Text>

                        <HStack spacing={2} mt={2}>
                            <Text fontWeight="bold">Tests:</Text>
                            <Badge colorScheme="blue">
                                {panel.tests?.length || 0}
                            </Badge>
                        </HStack>

                        {panel.tests?.length ? (
                            <UnorderedList pl={5}>
                                {panel.tests.map((t) => (
                                    <ListItem key={t._id || t}>{t.name || t}</ListItem>
                                ))}
                            </UnorderedList>
                        ) : (
                            <Text>No tests assigned</Text>
                        )}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
